// extracted by mini-css-extract-plugin
export default {"content":"PremiumRequiredModal_content__CJM+T","dialogText":"PremiumRequiredModal_dialogText__IzzGv"};